
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface NoGrowthDataMessageProps {
  heightData: any[];
  weightData: any[];
}

export function NoGrowthDataMessage({ heightData, weightData }: NoGrowthDataMessageProps) {
  const navigate = useNavigate();
  
  if (heightData.length > 0 || weightData.length > 0) {
    return null;
  }
  
  return (
    <div className="mt-8 p-6 border border-dashed rounded-lg text-center">
      <h3 className="text-lg font-medium mb-2">No growth data yet</h3>
      <p className="text-muted-foreground mb-4">
        Start tracking your baby's growth by recording height and weight measurements in your diary entries.
      </p>
      <Button onClick={() => navigate("/generate")}>Create New Entry</Button>
    </div>
  );
}
